import Swal from "sweetalert2";
import axios from "axios";

function DeleteAccount(props) {
  async function delete_account() {
    try {
      if (!props.checked) {
        Swal.fire({
          html: `<div>약관에 동의하셔야 계정삭제를 진행할 수 있습니다!</div>`,
        });
        return;
      }

      props.setOnProcess(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/delete`,
        {},
        {
          credentials: "same-origin",
          withCredentials: true,
        },
      );
      props.setOnProcess(false);

      Swal.fire({
        html: `<div>${res.data.message}</div>`,
      });

      props.setAfterLogin(false);
    } catch (e) {
      Swal.fire("계정 삭제 오류, 재시도 부탁드립니다!");
    }
  }

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
        }}
      >
        <input
          style={{
            cursor: "pointer",
          }}
          type={"checkbox"}
          checked={props.checked}
          onChange={(e) => {
            props.setChecked(!props.checked);
          }}
        />
        <div
          style={{
            padding: "0 0 0 10px",
          }}
        >
          계정 삭제 시, 관련 데이터는 영구 삭제 및 회복이 불가능 합니다.
        </div>
      </div>
      <div
        style={{
          padding: "30px 0 0 0",
        }}
      >
        <button
          style={{
            padding: "10px 20px",
            background: "red",
            border: "1px solid red",
            cursor: "pointer",
          }}
          onClick={delete_account}
        >
          Delete my Account
        </button>
      </div>
    </div>
  );
}

export default DeleteAccount;
